import { useLazyQuery } from "@apollo/client/react";import React, { useEffect, useState } from 'react';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';

import { adaptIndicacionesArray, GET_INDICATIONS_BY_EVALUACION } from '../../../../data/graphQL/queries/ResumenIngresoValidation/getIndicacionesByEvaluacion';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';

export const InsumosGridEvaluacion = ({ idDatosGeneralesRI, idTipoModulo, indicaciones, setIndicaciones, idEvaluacion }) => {

  const [getIndicaciones, { data: dataIndicaciones, loading: indicacionesLoading }] = useLazyQuery(GET_INDICATIONS_BY_EVALUACION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataIndicaciones) return;
    setIndicaciones(adaptIndicacionesArray(dataIndicaciones));
  }, [dataIndicaciones]);

  useEffect(() => {
    if (!idTipoModulo) return;
    getIndicaciones({variables: {
      idEvaluacion
    }});
  }, [idTipoModulo, idDatosGeneralesRI]);

  const columns = generateColumnsDefaultConfiguration([
  {
    headerName: 'Insumo',
    field: 'idInsumo',
    flex: 0.3
  },
  {
    headerName: 'Descripción',
    field: 'nombreInsumo',
    flex: 0.5
  },
  {
    headerName: 'Elección',
    field: 'eleccion',
    flex: 0.25
  },
  {
    headerName: 'Cantidad Diaria',
    field: 'cantidadDiaria',
    flex: 0.4

  },
  {
    headerName: 'Unidad',
    field: 'unidad',
    flex: 0.25
  },
  {
    headerName: 'Intervalo',
    field: 'intervalo',
    flex: 0.25
  },
  {
    headerName: 'Unidad tiempo',
    field: 'unidadTiempo',
    flex: 0.3
  }]
  );
  return <>
        <DataGridGenerico
      columns={columns}
      rows={indicaciones}
      loading={indicacionesLoading}
      toolbar={false} />
    
    </>;
};